import betoniAttrDataClass from "./betoniAttrDataClass";

export default class betoniAttrClass {
  constructor(keikkaBetoniId, keikkaId = null, tarjousId = null) {
    this.keikkaBetoniId = keikkaBetoniId;
    this.keikkaId = keikkaId;
    this.tarjousId = tarjousId;
    this.attr = [];
  }

  getAttrIndex(attrId) {
    for (var i = 0; i < this.attr.length; i++) {
      if (this.attr[i].attrId === attrId) {
        return i;
      }
    }
    return -1; // not found
  }
  removeAttr(attrId) {
    for (var i = 0; i < this.attr.length; i++) {
      if (this.attr[i].attrId === attrId) {
        this.attr.splice(i, 1);
      }
    }
  }
  containsAttr(attrId) {
    for (var i = 0; i < this.attr.length; i++) {
      if (this.attr[i].attrId === attrId) {
        return true;
      }
    }
    return false;
  }
  addAttr(attr) {
    if (attr == null) return;
    if (!this.containsAttr(attr.attrId)) {
      var bac = new betoniAttrDataClass();
      bac.keikkaBetoniAttrId = attr.keikkaBetoniAttrId;
      bac.attrId = attr.attrId;
      bac.attrHelpId = attr.attrHelpId;
      bac.attrNimike = attr.attrNimike;
      bac.keikkaBetoniAttrComment = attr.keikkaBetoniAttrComment;
      bac.keikkaId = this.keikkaId;
      bac.tarjousId = this.tarjousId;
      this.attr.push(bac);
    }
  }
}
